import React from "react";
import FAQList from "../../Components/FAQList";

const FAQs = () => {
  return <FAQList />;
};

export default FAQs;

